"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const navigation_1 = require("../organisms/navigation");
const hooks_1 = require("../shared/hooks");
const resources_1 = require("../resources");
const Layout = styled_components_1.default.section `
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-rows: 49px 1fr;
  position: relative;

  [data-svg="logo"] {
    height: 2rem;
    width: auto;
  }

  nav {
    padding: ${({ theme }) => theme.spacings.m};
  }

  [data-component="notification"] {
    position: absolute;
    left: 0;
    top: 49px;
    width: 100%;
    z-index: 1000;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    grid-template-rows: 1fr;
    min-height: 100vh;

    [data-component="notification"] {
      top: 0;
    }

    [data-svg="logo"] {
      height: 2.375rem;
    }
  }
`;
const Page = styled_components_1.default.section `
  display: grid;
  width: 100%;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  height: calc(100vh - 49px);
  overflow: auto;

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;
const Content = styled_components_1.default.section `
  align-self: center;
  justify-self: center;
`;
const Aside = styled_components_1.default.aside `
  align-self: stretch;

  img {
    width: 100%;
    height: calc(100vh - 49px);
    position: sticky;
    top: 0;
    object-fit: cover;
    pointer-events: none;
  }
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: none;
  }
`;
const Auth = ({ logoLink, children, logoSVG }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Layout, { children: [!isMobile && ((0, jsx_runtime_1.jsx)(navigation_1.TopNavigation, { isLogged: false, logoSVG: logoSVG ? logoSVG : (0, jsx_runtime_1.jsx)(resources_1.LogoCL_Black, {}, void 0), logoLink: logoLink }, void 0)), (0, jsx_runtime_1.jsxs)(Page, { children: [(0, jsx_runtime_1.jsx)(Content, { children: children }, void 0), (0, jsx_runtime_1.jsx)(Aside, { children: (0, jsx_runtime_1.jsx)(resources_1.AuthCoverMD, {}, void 0) }, void 0)] }, void 0)] }, void 0));
};
exports.default = Auth;
//# sourceMappingURL=Auth.js.map